<template>
	<div class="home-page">
		<div class="home-page__current-pools home-page__section">
			<router-link :to="{ name: 'current-pools' }" class="home-page__header">Your current pools <i class="material-icons">keyboard_arrow_right</i></router-link>
			<div class="logged-out" v-if="!authenticated">
				<button class="auth-button auth-button--primary" @click="SET_LOGIN_REGISTER(true)">Please Login or Signup!</button>
			</div>
			<div class="logged-in" v-else>
				<div class="no-pools" v-if="currentPools.length == 0">
					<p>You're not in any current pools.  <router-link class="no-pools__link" :to="{ name: 'create-pool' }">Create</router-link> or <router-link class="no-pools__link" :to="{ name: 'join-pool' }">Join</router-link> one today!</p>
				</div>
				<router-link v-else :to="{ name: currentPool.api_path, params: { poolId: currentPool.id } }" class="current-pool" v-for="(currentPool,index) in currentPools" :key="currentPool.id + currentPool.api_path" :class="{ 'active-pool': activePool == index }">
					<div class="pool-data">
						<div>
							<p class="pool-data--name">{{ currentPool.name }}</p>
							<p class="pool-data--event">{{ currentPool.event }}</p>
						</div>
						<div class="pool-data--right">
							<router-link :to="{ name: 'manage-'.concat(currentPool.api_path), params: { poolId: currentPool.id } }" class="btn text-color--secondary current-pool--manage" v-if="currentPool.user_is_manager">Manage Pool</router-link>
						</div>
					</div>
					<div class="pools-selector--icons" v-if="currentPools.length > 1">
						<div class="pools-selector--icon" v-for="(currentPool, index) in currentPools" :key="currentPool.id + currentPool.api_path" :class="{ 'active-icon': activePool == index }">
						</div>
					</div>
				</router-link>
				<div class="pools-selector" v-if="currentPools.length > 1">
					
					<div class="pools-selector--arrows">
						<button @click.prevent="navigateBefore">
							<i class="material-icons md-36">navigate_before</i>
						</button>
						<button @click.prevent="navigateNext">
							<i class="material-icons md-36">navigate_next</i>
						</button>
					</div>
					
				</div>
			</div>
		</div>

		<div class="home-page__upcoming home-page__section">
			<h3 class="home-page__header">Current Games</h3>
			<p class="upcoming-events-header">You can currently create a pool for the following events!</p>
			<div class="home-page__upcoming--block" v-for="league in leagues" :key="league.id">
				<h4 class="league">{{ league.name }}</h4>
				<div class="event-block" v-for="event in league.available_events" :key="event.id">
					<p class="event-block--header">{{ event.name }}</p>
					<ul>
						<li v-for="game in event.available_games" :key="game.id">
							<router-link :to="{ name: 'about-'.concat(game.api_path) }" class="about-link">
								{{ game.name }}
							</router-link>
						</li>
					</ul>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex'

	export default {
		data() {
			return {
				activePool: 0
			}
		},
		computed: {
			...mapGetters([
				'authenticated',
				'user',
				'leagues',
				'currentPools',
			]),
		},
		methods: {
			...mapMutations([
				'SET_LOGIN_REGISTER'
			]),
			navigateNext() {
				if(this.activePool == this.currentPools.length - 1) {
					this.activePool = 0
				} else {
					this.activePool = this.activePool + 1
				}
			},
			navigateBefore() {
				if(this.activePool == 0) {
					this.activePool = this.currentPools.length - 1
				} else {
					this.activePool = this.activePool - 1
				}
			}
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/home';
</style>